export enum StudyReportTypeModalityEnum {
  Legacy = 1,
  TxControl = 2
}
